import { render, staticRenderFns } from "./REGIONS.vue?vue&type=template&id=4e8bebf2&"
import script from "./REGIONS.vue?vue&type=script&lang=js&"
export * from "./REGIONS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports